import generalInformation from './generalInformation'
import fragilities from './fragilities'

const pages = { generalInformation, fragilities }

export default pages
